import { Delete, ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, CardContent, CardHeader, CardMedia, Grid, IconButton, Paper, Tooltip } from '@mui/material'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { postDelete } from 'global/postFunc'
import { serverUrl } from 'global/variable'
import userStore from 'store/userStore'
import Swal from 'sweetalert2'

const ImagePreview = ({
    dokumentasi,
    monevData,
    ta,
    setUpdating,
    updating,
    allowEdit
}) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const hapusDokumentasi = (params) => {
        Swal.fire({
            title: `Hapus Data?`,
            text: `Dokumentasi akan Dihapus`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/sa/monev/delete-dokumentasi',
                    {
                        _method: 'DELETE',
                        id: params.id,
                        id_komponen: monevData.id_komponen,
                        ta: ta
                    },
                    decryptedUser,
                    () => { setUpdating(!updating) },
                    null
                )
            }
        })
    }

    return (
        <Paper
            sx={{
                height: '300px',
                width: '100%',
                position: 'relative'
            }}
            variant='outlined'
        >
            <CardMedia
                component="img"
                image={`${serverUrl}/uploads/monev/${ta}/${monevData.id_komponen}/${monevData.id}/${dokumentasi.filename}`}
                alt="Dokumentasi"
                sx={{
                    m: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'contain'
                }}
            />
            {
                allowEdit &&
                <Tooltip title="Hapus Dokumentasi">
                    <IconButton
                        aria-label="delete"
                        color="error"
                        onClick={() => hapusDokumentasi(dokumentasi)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0
                        }}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
            }
        </Paper>
    )
}

const ListMonev = ({
    monevData,
    ta,
    setUpdating,
    updating,
    allowEdit
}) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const hapusMonev = (id) => {
        Swal.fire({
            title: `Hapus Data?`,
            text: `Data Monev akan Dihapus`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/sa/monev/delete',
                    {
                        _method: 'DELETE',
                        id: id,
                        ta: ta,
                    },
                    decryptedUser,
                    null,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }
    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <ArgonTypography variant='subtitle2' fontWeight="bold">{monevData.uraian}</ArgonTypography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <ArgonTypography variant='caption' fontWeight="bold">Tanggal {monevData.tanggal}</ArgonTypography>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    {
                        monevData.dokumentasi.map((dokumentasi, index) => (

                            <Grid item xs={12} md={4} key={index}>
                                <ImagePreview
                                    dokumentasi={dokumentasi}
                                    monevData={monevData}
                                    ta={ta}
                                    setUpdating={setUpdating}
                                    updating={updating}
                                    allowEdit={allowEdit}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </AccordionDetails>
            <AccordionActions>
                <Button startIcon={<Delete />} color='error' variant='outlined'>Hapus</Button>
            </AccordionActions>
        </Accordion>
        // <Paper variant='outlined'>
        //     <CardHeader
        //         title={
        //             <>
        //                 <ArgonTypography variant='subtitle2' fontWeight="bold">{monevData.uraian}</ArgonTypography>
        //                 <ArgonTypography variant='caption' fontWeight="bold">Tanggal {monevData.tanggal}</ArgonTypography>
        //             </>
        //         }
        //         action={
        //             allowEdit &&
        //             <Tooltip title="Hapus Monev">
        //                 <IconButton aria-label="delete" color="error" onClick={() => hapusMonev(monevData.id)}>
        //                     <Delete />
        //                 </IconButton>
        //             </Tooltip>
        //         }
        //     />
        //     <CardContent>
        //         <Grid container spacing={2}>
        //             {
        //                 monevData.dokumentasi.map((dokumentasi, index) => (

        //                     <Grid item xs={12} md={4} key={index}>
        //                         <ImagePreview
        //                             dokumentasi={dokumentasi}
        //                             monevData={monevData}
        //                             ta={ta}
        //                             setUpdating={setUpdating}
        //                             updating={updating}
        //                             allowEdit={allowEdit}
        //                         />
        //                     </Grid>
        //                 ))
        //             }
        //         </Grid>
        //     </CardContent>
        // </Paper>
    )
}

export default ListMonev